import {
  MODULE_NAMESPACE as BAG_MODULE,
  POPULATE_STORE,
  IS_INITIAL_DATA_SET as IS_BAG_INITIAL_DATA_SET,
  // SET_BAG_ERROR,
} from '@common-vue/my-bag-consumable';
import {
  MODULE_NAMESPACE as CHECKOUT_MODULE,
  POPULATE_STORE as CHECKOUT_POPLUATE_STORE,
  STS_MODULE_NAMESPACE,
  STS_POPULATE_STORE,
} from '@common-vue/my-checkout-consumable';
import { bmsmStore, BMSM_MODULE_NAME } from '@common-vue/buy-more-save-more';
import { vasStore, VAS_MODULE_NAME } from '@common-vue/value-added-services';
import store from '@common-vue/bag-checkout-common-consumable/src/store';
import { PAGE_DATA_REVALIDATED, SET_INITIAL_PAGE_DATA, SET_INITIAL_PAGE_ERROR } from '@types/actions';
import { IS_INITIAL_DATA_SET } from '@types/getters';

const BAG = 'Bag';
const CHECKOUT = 'Checkout';
const SAVE_THE_SALE = 'Save the Sale';
// TODO: MEDIUM expose this from bag-consumable
const SET_BAG_ERROR = 'Set Bag Error';
export default {
  namespaced: true,
  ...store,
  modules: {
    ...store.modules,
    [BMSM_MODULE_NAME]: bmsmStore,
    [VAS_MODULE_NAME]: vasStore,
  },
  mutations: {
    ...store.mutations,
    dataRevalidationState(state, valueObj /* {value: undefined|true|false, success: Boolean, hasUpdates, undefined|true|false} */) {
      state.revalidationState = valueObj;
    },
  },

  actions: {
    /* The following actions are already created via the CLI
    (polaris/core/build-vue/-/blob/master/lib/create-router-store.js)
    setExpIds
    */
    [PAGE_DATA_REVALIDATED]({ commit }, { success, hasUpdates }) {
      // TODO: LOW when SW is stable, remove this line
      if (success === true && hasUpdates === undefined) {
        // eslint-disable-next-line no-console
        console.error('PAGE_DATA_REVALIDATED has success true and hasUpdates undefined. Older SW must be still in control.');
      }
      commit('dataRevalidationState', { value: true, success, hasUpdates });
    },

    [SET_INITIAL_PAGE_DATA]({ dispatch }, { pageName, data }) {
      switch (pageName) {
      case BAG:
        dispatch(`${BAG_MODULE}/${POPULATE_STORE}`, data.bag);
        break;
      case CHECKOUT:
        dispatch(`${CHECKOUT_MODULE}/${CHECKOUT_POPLUATE_STORE}`, data);
        break;
      case SAVE_THE_SALE:
        dispatch(`${STS_MODULE_NAMESPACE}/${STS_POPULATE_STORE}`, data);
        break;
      default:
        break;
      }
    },

    [SET_INITIAL_PAGE_ERROR]({ commit }, { pageName }) {
      switch (pageName) {
      case BAG:
        commit(`${BAG_MODULE}/${SET_BAG_ERROR}`);
        break;
      default:
        break;
      }
    },
  },
  getters: {
    ...store.getters,
    [IS_INITIAL_DATA_SET]: (state, getters) => {
      const { pageName } = state.pageData;
      return pageName === BAG ? getters[`${BAG_MODULE}/${IS_BAG_INITIAL_DATA_SET}`] : false;
      // TODO: fix it for Checkout
    },
  },
};
